import React from "react";
import { DropdownMenu as DropdownMenuUI } from "../dropdown-menu";
import { DropdownMenuTrigger } from "./DropdownMenuTrigger";
import { DropdownMenuContent } from "./DropdownMenuContent";
import { DropdownMenuProps } from "./types";

export const DropdownMenu = <DataT,>({
  menuItems,
  icon,
  label,
  item,
}: DropdownMenuProps<DataT>) => {
  return (
    <DropdownMenuUI>
      <DropdownMenuTrigger icon={icon} label={label} />
      <DropdownMenuContent menuItems={menuItems} item={item} />
    </DropdownMenuUI>
  );
};

export type { Action, DropdownMenuProps } from "./types";
export { DropdownMenuVariant } from "./types";
